import React from 'react';
import { Box, Badge, Stack } from '@mui/material';
import { useRecoilState, useRecoilValue } from 'recoil';
import { toggleSspModels, isStorageDiskConfigFullfilled, sspSubmitOrder } from 'pages/provisioning/store/day2-operation';
import ProvisioningStyles from 'pages/provisioning/day2-operation/style';
import Btn from 'components/button';
import { isStorageDiskFormFilled } from 'pages/provisioning/day2-operation/utils';
import Form from 'pages/provisioning/day2-operation/components/Form';

const ConfigureStorageDisk = () => {
    const [isOpen, setIsOpen] = useRecoilState(toggleSspModels);
    const [isStorageConfig, setIsStorageConfig] = useRecoilState(isStorageDiskConfigFullfilled);
    const order = useRecoilValue(sspSubmitOrder);
    const getVariant = () => {
        if (!order?.diskSku) return 'standard';
        if (isStorageConfig === false) return 'dot';
        return 'standard';
    };
    React.useEffect(() => {
        setIsStorageConfig(!isStorageDiskFormFilled({ order }) && !isOpen?.isStorageDiskModalOpen);
    }, [order?.skuConfig, order?.maxIops, order?.ram, order?.dataDiskSupport, order?.premiumDiskSupport]);
    return (
        <>
            <Stack direction="row" spacing={1} my={2} sx={ProvisioningStyles.configure.stack}>
                <Box sx={ProvisioningStyles.configure.boxWrapper}>
                    <Form.DiskSku />
                </Box>
                <Box sx={ProvisioningStyles.configure.btnWrapper}>
                    <Badge sx={ProvisioningStyles.configure.badgeWidth} color="error" variant={getVariant()}>
                        <Btn
                            className="btn-disabled custom-btn"
                            fullWidth
                            onClick={() => setIsOpen({ ...isOpen, isStorageDiskModalOpen: true })}
                            size="small"
                            sx={ProvisioningStyles.configure.configureBtn}
                            variant="contained"
                            color="cmpPrimary"
                            disabled={!order?.diskSku}
                        >
                            Configure *
                        </Btn>
                    </Badge>
                </Box>
            </Stack>
        </>
    );
};

export default ConfigureStorageDisk;
